module.exports = __webpack_public_path__ + "img/feature_image.3335bec4.png";